import { useContext, useEffect, useState } from 'react';
import MapContext from '../Map/MapContext';
import OLVectorLayer from 'ol/layer/Vector';
import { vector } from '../Source';

const VectorLayer = ({ children, style, zIndex = 0 }) => {
    const { map } = useContext(MapContext);
    const [olLayer, setOlLayer] = useState();
    const [source] = useState(vector({}));
    // const [features, setFeatures] = useState({});

    useEffect(() => {
        if (!map) return;

        let vectorLayer = new OLVectorLayer({
            source,
            style,
        });

        map.addLayer(vectorLayer);
        // vectorLayer.setZIndex(zIndex);
        setOlLayer(vectorLayer);

        return () => {
            if (map) {
                map.removeLayer(vectorLayer);
            }
        };
    }, [map, source, style]);

    // useEffect(() => {
    //     if (!map || !olLayer) return;

    //     olLayer.setSource(source);
    // }, [map, source]);

    useEffect(() => {
        if (!map || !olLayer) return;

        olLayer.setZIndex(zIndex);
    }, [map, zIndex, olLayer]);

    useEffect(() => {
        children.forEach((child) => {
            if (Array.isArray(child)) {
                source.addFeatures(child);
            } else if (child) {
                source.addFeature(child);
            }
        });
        // setFeatures((prevFeatures) => {
        //     const keyParameter = 'ol_uid';
        //     const newFeatures = children.filter(
        //         (child) => !prevFeatures[child[keyParameter]]
        //     );
        //     console.log('newFeatures:', newFeatures);
        //     const removedFeatures = Object.keys(prevFeatures).filter((key) =>
        //         children.every((child) => child[keyParameter] !== key)
        //     );

        //     removedFeatures.forEach((f) => source.removeFeature(features[f]));
        //     source.addFeatures(newFeatures);

        //     // Put added features in new state:
        //     let newState = newFeatures.reduce((acc, cur) => {
        //         return { ...acc, [cur[keyParameter]]: cur };
        //     }, {});
        //     // Copy all features from previous state that are not removed to newState:
        //     newState = Object.keys(prevFeatures).reduce(
        //         (acc, cur) =>
        //             removedFeatures.indexOf(cur) >= 0
        //                 ? acc
        //                 : { ...acc, [cur]: prevFeatures[cur] },
        //         newState
        //     );
        //     return newState;
        // });

        return () => {
            children.forEach((child) => {
                if (Array.isArray(child)) {
                    child.forEach((f) => source.removeFeature(f));
                } else if (child) {
                    source.removeFeature(child);
                }
            });
        };
    }, [children, source]);

    return null;
};

export default VectorLayer;
